
    Date.prototype.monthNames = [
		"January", "February", "March", "April", "May", "June",
  		"July", "August", "September", "October", "November", "December"
	];
	
	Date.prototype.monthShortNames = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];
	
	Date.prototype.dayOfTheWeekNames = [
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	];
	
	Date.prototype.addDays = function(days) {
    	var date = new Date(this.valueOf());
    	date.setDate(date.getDate() + days);
    	return date;
	}
	
	Date.prototype.firstOfMonth = function() {
		var date = new Date(this.valueOf());
    	date.setDate(1);
    	return date;
	}
	
	Date.prototype.addMonths = function(months) {
    	var date = new Date(this.valueOf());
    	date.setMonth(date.getMonth() + months);
    	return date;
	}
	
	Date.prototype.isEqualDate = function(date) {
  		return this.getDate() == date.getDate() &&
    		this.getMonth() == date.getMonth() &&
    		this.getFullYear() == date.getFullYear();
	}
	
	Date.prototype.isToday = function() {
    	return this.isEqualDate(new Date());
	}
	
	Date.prototype.getMonthName = function() {
		return this.monthNames[this.getMonth()];
	}
	
	Date.prototype.getMonthShortName = function() {
		return this.monthShortNames[this.getMonth()];
	}
	
	Date.prototype.getDayOfTheWeekName = function() {
		return this.dayOfTheWeekNames[this.getDay()];
	}


	var calendarDate = new Date();
	var calendarListView = window.innerWidth < 700;

const formatDateTime = function(date) {
    var ampm = "am";
    var hours = date.getHours();
    const minutes = date.getMinutes();
    if (hours === 0) {
      hours = 12;
    } else if (hours === 12) {
      ampm = "pm";
    } else if (hours > 12) {
      hours -= 12;
      ampm = "pm";
    }
    return hours + ":" + (minutes <= 9 ? "0" + minutes : minutes) + " " + ampm;
}
	

const createEventMarkup = function(event, dateIndex) {
	if (event.isNote) {
		return "<div class='calendar-note'>" + event.title + "</div>";
	}
	const started = event.dates[0] <= new Date();
	const past = event.dates[dateIndex].addDays(1) <= new Date();  
	var markup = "<img src='" + event.imgUrl + "'>";
	if (past) {
		markup += "<div  class='wrong-month'>"
	} else {
		markup += "<div>"
	}
	if (!started) {
		markup +=	"<a href='" + event.eventUrl + "'>"
	}
	markup += formatDateTime(event.dates[dateIndex]) + ": " + event.title +  "<br>" + event.series;
	if (event.dates.length > 1) {
		markup += "<br>" + event.sessionTemplate.replace('#',dateIndex+1);
	}
	if (!started) {
		markup +=	"</a>";
	}
	markup +=	"</div>";
	return markup;
}
	
const renderCalendarGrid = function(date, id) {
		var year = date.getFullYear();
		var month = date.getMonth();
		var monthName = date.getMonthName();
		var firstDay = new Date(year, month, 1);
		var date = firstDay.addDays(-firstDay.getDay());
		var markup = "";
		var weeks = Math.ceil((firstDay.getDay() + new Date(year, month + 1, 0).getDate()) / 7);
		for (var week=0; week < weeks; week++) {
			markup += "<tr>"
			for (var i=0; i < 7; i++) {
				if (date.getMonth() === month) {
					if (date.isToday()) {
						markup += "<td class='today'>" + date.getDate()
					} else {
						markup += "<td>" + date.getDate()
					}
					
				} else {
					markup += "<td class='wrong-month'>" + date.getDate()
                }
                var eventList = []; 
				for (var e = 0; e < calendarEvents.length; e++) {
                    calendarEvents[e].dates.sort(function(a,b){return a.getTime() - b.getTime()});
					for (var d = 0; d < calendarEvents[e].dates.length; d++) {
						if (calendarEvents[e].dates[d].isEqualDate(date)) {
                            eventList.push({e:calendarEvents[e], d:d});
						}
					}
				}
                eventList.sort(function(a,b){return a.e.dates[a.d].getTime() - b.e.dates[b.d].getTime()});
                for (var e = 0; e < eventList.length; e++) {
                    markup += "<br>" + createEventMarkup(eventList[e].e,eventList[e].d);
                }
				date = date.addDays(1);
				markup += "</td>"
			}
			markup += "</tr>"
		}
		$("#" + id).html(
			"<table class='calendar'>" + 
				"<tr>" + 
					"<th><button type='button' id='calendarBack' >&lt;</button></th>" +
					"<th colspan='5'>" + monthName + " " + year + "<br><button type='button' id='calendarView' >Switch View</button></th>" +
					"<th><button type='button' id='calendarForward' >&gt;</button>" +
				"</tr>" +
				"<tr>" +
					"<th>Su</th><th>Mo</th><th>Tu</th><th>We</th><th>Th</th><th>Fr</th><th>Sa</th>" +
				"</tr>" +
				markup +
			"</table>"
		);
	}
	
	const renderCalendarList = function(date, id) {
		var year = date.getFullYear();
		var month = date.getMonth();
		var monthName = date.getMonthName();
		var date = new Date(year, month, 1);
		var markup = "";
		do {
			var dateMarkup = ""
			var eventList = []; 
            for (var e = 0; e < calendarEvents.length; e++) {
                calendarEvents[e].dates.sort(function(a,b){return a.getTime() - b.getTime()});
                for (var d = 0; d < calendarEvents[e].dates.length; d++) {
                    if (calendarEvents[e].dates[d].isEqualDate(date)) {
                        eventList.push({e:calendarEvents[e], d:d});
                    }
                }
            }
            eventList.sort(function(a,b){return a.e.dates[a.d].getTime() - b.e.dates[b.d].getTime()});
            for (var e = 0; e < eventList.length; e++) {
                dateMarkup += "<br>" + createEventMarkup(eventList[e].e,eventList[e].d);
            }
			if (dateMarkup) {
				markup += "<tr><td colspan='3'>" + date.getDayOfTheWeekName() + ", " + date.getMonthShortName() + " " + date.getDate() + "<br>" +
					dateMarkup + "</td></tr>";
			}
			date = date.addDays(1);
		} while (date.getDate() != 1);
		if (!markup) {
			markup += "<tr><td colspan='3'>No Events</td></tr>";
		}
		$("#" + id).html(
			"<table class='calendar'>" + 
				"<tr>" + 
					"<th><button type='button' id='calendarBack' >&lt;</button></th>" +
					"<th>" + monthName + " " + year + "<br><button type='button' id='calendarView' >Switch View</button></th>" +
					"<th><button type='button' id='calendarForward' >&gt;</button>" +
				"</tr>" +
				markup +
			"</table>"    
		);
	}
	
	const renderCalendar = function(date, id) {
		calendarListView ? renderCalendarList(date,id) : renderCalendarGrid(date,id);
	}


	$( document ).ready(function() {
		if ($("#calendar")) {
			renderCalendar(calendarDate, "calendar");

			$('#calendar').on('click','button', function (event) {
				if ($(this).attr('id') === 'calendarBack') {
  					calendarDate = calendarDate.firstOfMonth().addMonths(-1);
  				} else if ($(this).attr('id') === 'calendarForward') {
  					calendarDate = calendarDate.firstOfMonth().addMonths(1);
  				} else if ($(this).attr('id') === 'calendarView') {
  					calendarListView = !calendarListView;
  				}
  				renderCalendar(calendarDate, "calendar");
			});
		}
	});